import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// The RSVP invite is a standalone static page in public/rsvp/. If a host or the
// dev server hands /rsvp (no trailing slash) to the React app, bounce to /rsvp/.
if (/^\/rsvp$/i.test(window.location.pathname)) {
  window.location.replace('/rsvp/' + window.location.search + window.location.hash);
} else {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
